// Campus photo for /colleges/san-jose-state-university: CC BY-SA 4.0, by Norwich1856, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ATower_Hall%2C_San_Jose%2C_CA.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/san-jose-state-university/; credited under the photo.
const photo = {
    "slug": "san-jose-state-university",
    "alt": "Tower Hall, built in 1910, and the lawn in front of it at San Jose State University in San Jose, California",
    "src": "/colleges/san-jose-state-university/campus-1600.webp",
    "srcSmall": "/colleges/san-jose-state-university/campus-800.webp",
    "srcMid": "/colleges/san-jose-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/san-jose-state-university/og.jpg",
    "title": "Tower Hall, San Jose, CA",
    "author": "Norwich1856",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ATower_Hall%2C_San_Jose%2C_CA.jpg",
    "read": "2026-10-01"
};

export default photo;
